import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, Typography, Card, CardContent, Link } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import img from "../assets/qural1.png";
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { makeApiRequest } from '../utils/api';

function OtpVerification() {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';

  useEffect(() => {
    if (!email) {
      navigate('/forgot-password');
    }
  }, [email, navigate]);

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (!otp) {
      setError('OTP is required.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const response = await makeApiRequest('post', '/api/forgot-password/verify-otp', {
        email,
        otp
      });
      if (response.status === 'success') {
        navigate('/reset-password', { state: { email, otp } });
      } else {
        setError(response.message || 'Invalid or expired OTP.');
      }
    } catch (err) {
      console.error('Error verifying OTP:', err);
      setError(err.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden' }}>
      <Box
        sx={{
          width: '100%',
          height: '60vh',
          background: 'linear-gradient(to right, #2353A3 0%, #59C8F2 50%, #FFFFFF 100%)',
        }}
      />
      <Box
        sx={{
          width: 0,
          height: 0,
          borderLeft: '100vw solid transparent',
          borderBottom: '13.9vw solid #ffffff',
          marginTop: '-13.8vw',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '80%', sm: '50%', md: "35%" },
          padding: '20px',
          backgroundColor: 'transparent',
          zIndex: 10,
        }}
      >
        <Card sx={{ borderRadius: '8px', boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)' }}>
          <CardContent>
            <Typography variant="h5" component="h2" sx={{ marginBottom: '30px', color: '#333', textAlign: 'center' }}>
              <img style={{ height: "122px", objectFit: 'contain', width: '100%' }} src={img} alt="Logo" />
            </Typography>
            <Typography variant="h6" sx={{ marginBottom: '20px', textAlign: 'center', fontWeight: 'bold' }}>
              Enter OTP
            </Typography>
            <Typography variant="body2" sx={{ marginBottom: '20px', textAlign: 'center', color: '#666' }}>
              We sent a verification code to <strong>{email}</strong>. It is valid for 2 hours.
            </Typography>
            {error && (
              <Typography variant="body2" color="error" sx={{ marginBottom: 2, textAlign: 'center' }}>
                {error}
              </Typography>
            )}
            <Box component="form" onSubmit={handleVerifyOtp} noValidate>
              <Box sx={{ marginBottom: 4 }}>
                <TextField
                  fullWidth
                  label="OTP Code"
                  type="text"
                  placeholder="Enter 6-digit OTP"
                  variant="outlined"
                  required
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  InputProps={{
                    endAdornment: <LockOpenIcon />,
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Box>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={loading}
                sx={{
                  backgroundColor: '#007BFF',
                  '&:hover': { backgroundColor: '#0056b3' },
                  marginBottom: 2
                }}
              >
                {loading ? 'Verifying...' : 'Verify OTP'}
              </Button>
              <Box sx={{ textAlign: 'center' }}>
                <Link
                  component="button"
                  type="button"
                  onClick={() => navigate('/forgot-password')}
                  sx={{ fontSize: '14px', color: '#007BFF', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                >
                  Back
                </Link>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export default OtpVerification;
